const SEO = [
	{
		page: "home",
		description:
			"I am a backend developer with expertise in Node.js. I have experience in building scalable, secure and reliable web applications using various frameworks and technologies.",
		keywords: ["Hamoun", "Hamoun D", "Hamoun Dolatshahi"],
	},

	{
		page: "writer",
		description:
			"All work related to writing in movies, TV shows, and other media. I have a passion for storytelling and enjoy exploring different genres and formats.",
		keywords: ["Hamoun", "Hamoun D", "Hamoun Dolatshahi","Seeking Refuge","Black List Evaluation","Prospects"],
	},

	{
		page: "director",
		description:
			"Chronological collection of my long-form thoughts on programming, leadership, product design, and more.",
		keywords: ["Hamoun", "Hamoun D", "Hamoun Dolatshahi"],
	},

	{
		page: "actor",
		description:
			"I've worked on a variety of projects over the years and I'm proud of the progress I've made as an actor.",
		keywords: ["Hamoun", "Hamoun D", "Hamoun Dolatshahi"],
	},

	{
		page: "producer",
		description:
			"If you're interested in collaborating on a project, feel free to reach out to me. I'm always open to new ideas and opportunities.",
		keywords: ["Hamoun", "Hamoun D", "Hamoun Dolatshahi"],
	},
	{
		page: "editor",
		description:
			"If you're interested in collaborating on a project, feel free to reach out to me. I'm always open to new ideas and opportunities.",
		keywords: ["Hamoun", "Hamoun D", "Hamoun Dolatshahi"],
	},
];

export default SEO;
